/**
 * Bybit Exchange Metadata
 */

import { BYBIT_WS_CHANNELS, BYBIT_WS_TOPOLOGY } from './ws';

import type { ExchangeId, ExchangeMetadata } from '../../lib/types';

export const BYBIT_METADATA: ExchangeMetadata = {
  id: 'bybit' as ExchangeId,
  restDocs: ['https://bybit-exchange.github.io/docs/v5/intro'],
  wsDocs: ['https://bybit-exchange.github.io/docs/v5/ws/connect'],
  wsTopology: BYBIT_WS_TOPOLOGY,
  wsChannels: BYBIT_WS_CHANNELS,
  notes: [
    'Uses V5 API with categories (spot, linear, inverse, option).',
    'Client must send ping every 20 seconds.',
    'Multiple topics can be subscribed via a single connection.',
  ],
};
